var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { LitElement, html, css } from 'lit';
import { property, customElement } from 'lit/decorators.js';
import { styleMap } from 'lit/directives/style-map.js';
import { ifDefined } from 'lit/directives/if-defined.js';
import { env } from '../environment';
import style from '../css/icon.css';
let Icon = class Icon extends LitElement {
    constructor() {
        super(...arguments);
        this.disabled = undefined;
        this.cursor = undefined;
        this.version = '';
        this.family = 'fas';
        this.type = 'fa-barcode';
        this.dt_invert = false;
        this.dt_first_color = 'currentColor';
        this.dt_second_color = 'currentColor';
        this.dt_first_opacity = 'inherit';
        this.dt_second_opacity = 'inherit';
    }
    static get styles() {
        if (env.debug) {
            return css `
        `;
        }
        return [style];
    }
    updated() {
        this.loadCSSIfNotAlreadyLoaded();
    }
    loadCSSIfNotAlreadyLoaded() {
        var fa_src = "https://kit.fontawesome.com/352997b648.js";
        var fa_script = document.createElement("script");
        fa_script.src = fa_src;
        fa_script.crossOrigin = "anonymous";
        if (!document.head.querySelector("script[src='" + fa_src + "']")) {
            document.getElementsByTagName("head")[0].appendChild(fa_script);
        }
    }
    render() {
        var dt_swap_opacity = '';
        if (this.family == 'fad') {
            if (this.dt_invert) {
                dt_swap_opacity = 'fa-swap-opacity';
            }
        }
        const styles = {
            '--fa-primary-color': this.family == 'fad' && !this.disabled ? this.dt_first_color : 'currentColor',
            '--fa-secondary-color': this.family == 'fad' && !this.disabled ? this.dt_second_color : 'currentColor',
            '--fa-primary-opacity': this.family == 'fad' && !this.disabled ? this.dt_first_opacity : 'inherit',
            '--fa-secondary-opacity': this.family == 'fad' && !this.disabled ? this.dt_second_opacity : 'inherit',
            cursor: this.cursor,
        };
        var iconEl = html `<i part="ico" class="${this.family} ${this.type} ${dt_swap_opacity}" disabled="${ifDefined(this.disabled)}" style=${styleMap(styles)}></i>`;
        return html `
        ${env.debug ? html `<link rel="stylesheet" href="/css/icon.css" />` : html ``}
        
        ${this.version == 'elevated' || this.version == 'floating' ?
            html `<button class="btn-icon btn-icon-${this.version}" ?disabled=${this.disabled}>${iconEl}</button>` : iconEl}`;
    }
};
__decorate([
    property({ reflect: true })
], Icon.prototype, "disabled", void 0);
__decorate([
    property()
], Icon.prototype, "cursor", void 0);
__decorate([
    property()
], Icon.prototype, "version", void 0);
__decorate([
    property()
], Icon.prototype, "family", void 0);
__decorate([
    property()
], Icon.prototype, "type", void 0);
__decorate([
    property()
], Icon.prototype, "dt_invert", void 0);
__decorate([
    property()
], Icon.prototype, "dt_first_color", void 0);
__decorate([
    property()
], Icon.prototype, "dt_second_color", void 0);
__decorate([
    property()
], Icon.prototype, "dt_first_opacity", void 0);
__decorate([
    property()
], Icon.prototype, "dt_second_opacity", void 0);
Icon = __decorate([
    customElement('gs1-fa-icon')
], Icon);
export { Icon };
//# sourceMappingURL=icon.js.map